import { SettingOutlined, TeamOutlined } from '@ant-design/icons';
import { Button, Card, Space, Table, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';

const AutorizacionEmpresa = () => {
  const {
    params: { id: idEmpresa }
  } = useRouteMatch();
  const [loading, setLoading] = useState();
  const [empresaProducto, setEmpresaProducto] = useState();
  const [empresa, setEmpresa] = useState();
  const history = useHistory();

  const columns = [
    {
      title: 'Producto',
      dataIndex: ['producto', 'descripcion'],
      key: ['producto', 'descripcion']
    },
    {
      title: 'Acciones',
      key: 'action',
      width: '10px',
      align: 'left',
      render: (text, record) => {
        return (
          <Space size="small">
            <Tooltip title="Verificadores">
              <Button
                icon={<TeamOutlined />}
                type="text"
                size="middle"
                onClick={() => handleOpenVerificadores(record.id)}
              />
            </Tooltip>
            <Tooltip title="Configuración">
              <Button
                // disabled
                icon={<SettingOutlined />}
                type="text"
                size="middle"
                onClick={() => handleOpenConfig(record.id)}
              />
            </Tooltip>
          </Space>
        );
      }
    }
  ];

  const handleOpenConfig = (id) => {
    const urlConfig = `/autorizacion-configuracion/empresaProducto/${id}`;
    history.push(urlConfig);
  };

  const handleOpenVerificadores = (id) => {
    const urlVerificadores = `/verificadores/empresaProducto/${id}`;
    history.push(urlVerificadores);
  };

  const getProductosByEmpresa = async () => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get(
        `/empresaproducto/empresa/${idEmpresa}`
      );
      if (response.data?.data) {
        setEmpresaProducto(response.data.data.rows);
        setEmpresa(response.data.data.rows[0].empresa);
      }

      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getProductosByEmpresa();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ResponsiveContainer size="large">
        <Card
          title={`Configuración de Autorizaciones - ${
            empresa?.nombre_corto || ''
          } `}
          style={{ textAlign: 'left' }}
        >
          <Table
            loading={{ spinning: loading, tip: 'Cargando...', delay: 500 }}
            fixed
            scroll={false}
            style={{ maxWidth: '500px', width: '100%' }}
            bordered
            dataSource={empresaProducto}
            columns={columns}
            pagination={false}
            rowKey={(record) => record.id}
            size="small"
          />
        </Card>
      </ResponsiveContainer>
    </>
  );
};

export default AutorizacionEmpresa;
